<template>
  <div class="_title" :class="{dark_mode: darkMode}">
    <slot></slot>
    <span>{{subtext}}</span>
  </div>
</template>

<script>
export default {
  props: {
    subtext: {
      type: String,
      default: '',
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  font-size: 16px;
  &.dark_mode {
    color: $baseColor;
  }
  span {
    font-size: 13px;
    margin-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  ._title {
    padding-left: 0;
  }
}
</style>
